module.exports = __webpack_public_path__ + "static/fcic-logo-5fee35d374a9027a3f80561b4f6b7fe1.png";